/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_Property_AddressInputs */

const cs_property_legal_property_address = /** @type {(inputs: Property_Legal_Property_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa nemovitosti`)
};

const en_property_legal_property_address = /** @type {(inputs: Property_Legal_Property_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property address`)
};

/**
* | output |
* | --- |
* | "Property address" |
*
* @param {Property_Legal_Property_AddressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_property_address = /** @type {((inputs?: Property_Legal_Property_AddressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_Property_AddressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_property_address(inputs)
	return cs_property_legal_property_address(inputs)
});